const getUser = (state) => state.get('user');
const getUserId = (state) => getUser(state).get('id');

// eslint-disable-next-line import/prefer-default-export
export const getIsLoggedUser = (state) => Boolean(getUserId(state));
